import { render } from "./ProfileNotificationSettings.vue?vue&type=template&id=4df27a0c&scoped=true"
import script from "./ProfileNotificationSettings.vue?vue&type=script&lang=js"
export * from "./ProfileNotificationSettings.vue?vue&type=script&lang=js"

import "./ProfileNotificationSettings.vue?vue&type=style&index=0&id=4df27a0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df27a0c"]])

export default __exports__